import SettingIcon from './SettingIcon';
export default SettingIcon;
